import Vue from 'vue'
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import IdleVue from "idle-vue";
import VueCrontab from 'vue-crontab';
import App from './App.vue'
import router from './router'
import store from './store'
import VueFormulate from '@braid/vue-formulate'
import FormulateVSelectPlugin from '@cone2875/vue-formulate-select'
import 'vue-select/dist/vue-select.css';
import Notifications from 'vue-notification'
import VueMeta from 'vue-meta';
import VueTippy from "vue-tippy";
import ConfirmationService from 'primevue/confirmationservice';

window.axios=require('axios');

Vue.use(PrimeVue);
Vue.use(ConfirmationService);
const eventsHub = new Vue();
Vue.use(VueFormulate, {
  plugins: [ FormulateVSelectPlugin ]
});
Vue.use(VueMeta);
Vue.use(VueCrontab);
Vue.use(Notifications);
Vue.use(IdleVue,{
  eventEmitter: eventsHub, store,
  idleTime: 1800000, // 3 seconds
  startAtIdle: false
});
Vue.use(VueTippy, {
    theme: 'khonsu',
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')